import * as React from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { StyledTabs, StyledTab } from 'components/Shared/StyledTabs';

import InfosLogistique from './InfosLogistique';
import InfosGenerales from './InfosGenerales';
import InfosFactureLitiges from './InfosFactureLitiges';
import InfosCommande from './InfosCommande';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const InfosPiece = ({ utilisateur, infosLogistique, isLoading, piece }) =>  // utilisateur à supprimer, unleash provider
{
    const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);

    const afficherOngletCommande = Boolean(piece.commandeGestionCle);

    React.useEffect(
        function pieceChangedEffect () {
            setSelectedTabIndex(0);
        },
        [piece]
    );

    const handleChange = (event, newValue) => {
        setSelectedTabIndex(newValue);
    };

    return (
        <Card sx={{marginLeft:2, marginRight:2, marginBottom:2}}>

            <StyledTabs
                value={selectedTabIndex}
                onChange={handleChange}
                aria-label="basic tabs example"
            >
                <StyledTab label="Infos Logistiques" {...a11yProps(0)} />
                <StyledTab label="Infos Générales" {...a11yProps(1)} />
                <StyledTab label="Facture / Litige" {...a11yProps(2)} sx={{ display: !piece.facture ? 'none' : undefined }} />
                <StyledTab label="Commande" {...a11yProps(3)} sx={{ display: !afficherOngletCommande ? 'none' : undefined }} />
            </StyledTabs>

            <TabPanel value={selectedTabIndex} index={0}>
                <InfosLogistique
                    isLoading={isLoading}
                    infosLogistique={infosLogistique}
                />
            </TabPanel>

            <TabPanel value={selectedTabIndex} index={1}>
                {
                    Boolean(infosLogistique.client) && Boolean(infosLogistique.client.code) && infosLogistique.client.code != '' &&
                    <InfosGenerales
                        isLoading={isLoading}
                        idClient={infosLogistique.client.id}
                        numeroPiece={piece.numeroPiece}
                    />
                }
            </TabPanel>

            <TabPanel value={selectedTabIndex} index={2}>
                {
                    piece.facture &&
                    <InfosFactureLitiges numeroPiece={piece.bonLivraisonGestionCle || piece.numeroPiece} />
                }
            </TabPanel>

            <TabPanel value={selectedTabIndex} index={3}>
                {
                    afficherOngletCommande &&
                    <InfosCommande commandeGestionCle={piece.commandeGestionCle} />
                }
            </TabPanel>

        </Card>
    )
}

export default InfosPiece;
